import React from "react"
import { Checkbox, FormControlLabel, FormHelperText, Switch, Tooltip } from "@mui/material";


export const InputCheck = ({
    label,
    name,
    value,
    onChange,
    tooltip,
    errors = [],
    disabled = false,
    ...others
}) => {

    return (
        <>
            <Tooltip title={tooltip} >
                < FormControlLabel disabled={disabled} {...others}
                    control={
                        < Checkbox
                            size="small"
                            checked={value}
                            onChange={(e) => {
                                onChange(name, e.target.checked ? true : false);
                            }}
                        />
                    }
                    label={label}
                />
            </Tooltip>
            {
                !!errors[name] && (
                    <FormHelperText error={!!errors[name]}>
                        {errors[name]}
                    </FormHelperText>
                )
            }
        </>



    )
}

export const InputSwitch = ({
    label,
    name,
    value,
    onChange,
    tooltip,
    errors = [],
    disabled = false,
    ...others
}) => {

    return (
        <>
            <Tooltip title={tooltip} >
                < FormControlLabel disabled={disabled} {...others}
                    control={
                        < Switch
                            size="small"
                            checked={value}
                            onChange={(e) => {
                                onChange(name, e.target.checked ? true : false);
                            }}
                        />
                    }
                    label={label}
                />
            </Tooltip>
            {
                !!errors[name] && (
                    <FormHelperText error={!!errors[name]}>
                        {errors[name]}
                    </FormHelperText>
                )
            }
        </>



    )
}